<template>
  <div class="my_search">
    <el-form
      :inline="true"
      :model="formData"
      :class="{ demo_form: showLabel1 == 7, demo_form2: is_width }"
    >
      <!-- 作业名称 -->
      <el-form-item
        :label="labelVal1"
        :class="{
          select01: is_width,
          select02: triggerPhName == 3 || triggerPhName == 8,
        }"
        v-if="show1"
      >
        <el-input v-model="formData.workName" :placeholder="phName" clearable></el-input>
      </el-form-item>
      <!-- -->
      <el-form-item
        :label="labelVal2"
        v-if="showIpt2"
        :class="{ ml20: classVal, select01: showLabel1 == 7 }"
      >
        <el-input v-model="formData.modelVal" :placeholder="phName4" clearable></el-input>
      </el-form-item>
      <!-- 请选择作业对象 -->
      <el-form-item class="select01" v-if="showSelect1" :label="labelVal4">
        <el-select v-model="formData.workPeople" :placeholder="phName2" clearable>
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, index) in list1"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 考核 -->
      <el-form-item class="select01" :label="labelVal5" v-if="show2">
        <el-select v-model="formData.assess" :placeholder="phName5" clearable>
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, index) in list2"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 是否完成 -->
      <el-form-item class="select01" :label="labelVal3" v-if="show3">
        <el-select v-model="formData.finish" :placeholder="phName6" clearable>
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, index) in list3"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <!--  -->
      <el-form-item class="download" label="允许下载：" v-if="show4">
        <el-select v-model="formData.download" placeholder="请选择">
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, index) in list4"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        class="btn_cls"
        :style="{ marginLeft: marginLeftVal, marginRight: marginRightVal }"
      >
        <el-button type="primary" size="mini" @click="onSearch">查询</el-button>
        <el-button size="mini" @click="onReset">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- MySearch -->
  </div>
</template>

<script>
export default {
  props: {
    list1: {
      type: Array,
    },
    list2: {
      type: Array,
    },
    list3: {
      type: Array,
    },
    list4: {
      type: Array,
    },
    show2: {
      type: Number,
      default: 1,
    },
    show4: {
      type: Number,
      default: 0,
    },
    show3: {
      type: Number,
      default: 1,
    },
    triggerPhName: {
      type: Number,
      default: 0,
    },
    triggerPhName2: {
      type: Number,
      default: 0,
    },
    showIpt2: {
      type: Number,
      default: 0,
    },
    showSelect1: {
      type: Number,
      default: 1,
    },
    showLabel1: {
      type: Number,
      default: 0,
    },
    classVal: {
      type: Number,
      default: 0,
    },
    is_width: {
      type: Number,
      default: 0,
    },
    marginLeftVal: {
      type: String,
      default: "30px",
    },
    marginRightVal: {
      type: String,
      default: "10px",
    },

    show1: {
      type: Number,
      default: 1,
    },
    is_reset: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      formData: {
        workName: undefined,
        workPeople: undefined,
        assess: undefined,
        finish: undefined,
        download: undefined,
      },
    };
  },
  watch: {
    formData: {
      handler(newVal) {
        this.$emit("changeVal", newVal);
      },
      deep: true,
    },
  },
  methods: {
    // 查询
    onSearch() {
      if (this.is_reset == 1) {
        // 重置radio
        this.$emit("resetRadioVal");
      }

      this.$emit("resetPage");
      this.$emit("requestCommonFn");
    },
    // 重置
    onReset() {
      this.resetIptVal();

      // 重置排序
      this.$emit("resetOrder");
      // 重置radio
      this.$emit("resetRadioVal");
      // 监听赋值完再请求接口
      setTimeout(() => {
        this.$emit("requestCommonFn");
      }, 100);
    },
    resetIptVal() {
      this.$set(this.formData, "workName", undefined);
      this.$set(this.formData, "workPeople", undefined);
      this.$set(this.formData, "assess", undefined);
      this.$set(this.formData, "finish", undefined);
      this.$set(this.formData, "modelVal", undefined);
      this.$set(this.formData, "download", undefined);
    },
  },
  computed: {
    phName() {
      return this.triggerPhName == 1
        ? "请输入问卷名称"
        : this.triggerPhName == 2
        ? "请输入资源名称"
        : this.triggerPhName == 3
        ? "请输入面授课名称"
        : this.triggerPhName == 4
        ? "请输入标题"
        : this.triggerPhName == 5
        ? "请输入姓名"
        : this.triggerPhName == 8
        ? "请输入讨论组名称"
        : this.triggerPhName == 9
        ? "请输入发布人"
        : this.triggerPhName == 10
        ? "请输入单位名称"
        : "请入作业名称";
    },
    phName2() {
      return this.triggerPhName2 == 1
        ? "请选择状态"
        : this.triggerPhName2 == 2
        ? "请选择项目"
        : this.triggerPhName2 == 3
        ? "请选择学习方式"
        : this.triggerPhName2 == 4
        ? "请选择隶属小组"
        : this.triggerPhName2 == 5
        ? "请选择签到状态"
        : this.triggerPhName2 == 6
        ? "请选择状态"
        : this.triggerPhName2 == 7
        ? "请选择类型"
        : this.triggerPhName2 == 8 || this.triggerPhName2 == 9
        ? "请选择"
        : "请选择作业对象";
    },
    phName3() {
      return this.triggerPhName2 == 4 ? "请选择批阅状态" : "请选择作业对象";
    },
    phName4() {
      return this.triggerPhName == 5
        ? "请输入手机号"
        : this.triggerPhName == 6
        ? "请输入授课内容"
        : this.triggerPhName == 7
        ? "请输入名称"
        : this.triggerPhName == 8
        ? "请输入发起人"
        : "请输入";
    },
    phName5() {
      return this.triggerPhName == 7 || this.triggerPhName == 9
        ? "请选择"
        : this.triggerPhName == 5
        ? "请选择提交状态"
        : "是否考核";
    },
    phName6() {
      return this.triggerPhName == 7
        ? "请选择状态"
        : this.triggerPhName == 9
        ? "请选择"
        : "是否完成";
    },
    labelVal1() {
      return this.showLabel1 == 1
        ? "标题："
        : this.showLabel1 == 2 || this.showLabel1 == 8
        ? "名称："
        : this.showLabel1 == 3 || this.showLabel1 == 4
        ? "姓名："
        : this.showLabel1 == 9
        ? "发布人："
        : this.showLabel1 == 10
        ? "单位名称："
        : "";
    },
    labelVal2() {
      return this.showLabel1 == 1
        ? "发布人："
        : this.showLabel1 == 5
        //? "签到状态："
        ? "学员姓名："
        : this.showLabel1 == 4
        ? "手机号："
        : this.showLabel1 == 6
        ? "授课内容："
        : this.showLabel1 == 7
        ? "名称："
        : this.showLabel1 == 8
        ? "发起人："
        : "";
    },
    labelVal3() {
      return this.showLabel1 == 3
        ? "是否完成："
        : this.showLabel1 == 4
        ? "批阅状态："
        : this.showLabel1 == 7
        ? "状态："
        : this.showLabel1 == 9
        ? "举报："
        : "";
    },
    labelVal4() {
      return this.showLabel1 == 3
        ? "学习方式："
        : this.showLabel1 == 4
        ? "隶属小组："
        : this.showLabel1 == 5
        ? "签到状态："
        : this.showLabel1 == 6
        ? "状态："
        : this.showLabel1 == 7
        ? "类型："
        : this.showLabel1 == 8
        ? "讨论组类型："
        : this.showLabel1 == 9
        ? "置顶："
        : "";
    },
    labelVal5() {
      return this.showLabel1 == 4
        ? "提交状态："
        : this.showLabel1 == 7
        ? "考核："
        : this.showLabel1 == 9
        ? "屏蔽："
        : "";
    },
  },
};
</script>

<style lang="less" scoped>
.my_search {
  /deep/ .demo_form {
    .el-form-item__label {
      padding: 0 2px 0 0;
    }
  }

  /deep/ .el-form {
    .el-input__inner {
      height: 32px;
      width: 150px;
    }
  }
  /deep/ .select01 {
    .el-input__inner {
      width: 150px;
    }
  }
  /deep/ .select02 {
    .el-input__inner {
      width: 160px;
    }
  }
  /deep/ .demo_form2 {
    .el-input__inner {
      width: 140px;
    }
    .download {
      margin-right: 0;
    }
    .el-form-item {
    }
  }
  .btn_cls {
    margin-left: 30px;
    .el-button {
      padding: 8px 20px;
    }
  }
}
</style>
